import * as React from 'react';
import "./InfoableComponent.css";
import { InfoHint } from './InfoHint';

export { Description } from './Description';

type InfoableComponentProps = {
    description?: string | JSX.Element | JSX.Element[];
}

const InfoableComponent = (props: React.PropsWithChildren<InfoableComponentProps>) => {
    const { description } = props;

    return <div className='infoable-component'>
        {props.children}
        {description && <InfoHint description={description} iconClassName='info-callout-icon' />}
    </div>;
}
export default InfoableComponent;